<template>
  <div class="title-tag">
    <h2>{{ title }}</h2>
  </div>
</template>

<script>
export default {
  name: 'TitleTag',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
}
</script>

<style>
.title-tag {
  position: relative;
  /*   margin: 25px 0px 15px; */
  margin: 25px 0px;
  padding-left: 16px;
  color: #18212f;
  font-size: 30px;
  text-align: left;
  line-height: 22px;
  letter-spacing: -0.84px;
}

.title-tag h2 {
  position: relative;
  vertical-align: baseline;
  border: 0;
  display: table;
  font-size: 20px;
}

.title-tag:after {
  display: block;
  content: '';
  width: 6px;
  height: 38px;
  background: #0fafd7;
  border-radius: 15px;
  top: 50%;
  left: 0;
  position: absolute;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

@media screen and (max-width: 656px) {
  .title-tag h2 {
    font-size: 16px;
  }
}
</style>
